import { render, staticRenderFns } from "./website_foot.vue?vue&type=template&id=5131555e"
import script from "./website_foot.vue?vue&type=script&lang=js"
export * from "./website_foot.vue?vue&type=script&lang=js"
import style0 from "./website_foot.vue?vue&type=style&index=0&id=5131555e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports